import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CustomerVerificationView } from '@sunbit-dev/purchase-common/src/components/customerVerificationView/CustomerVerificationView';
import { Loader } from '@sunbit-dev/web-ui-lib';
import { applyOnlineNetworkService } from '~/services/applyOnlineNetworkService';
import { addQueryParamsToUrl } from '@sunbit-dev/purchase-common/src/utilities/urls';
import ActionTypes from '~/constants/actionTypes';
import { ErrorDispatchContext } from '~/contexts/errorContext';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import { UserContext } from '~/contexts/userContext';
import { CustomerVerificationStyle } from './styles';
import { CustomerVerificationProps } from './models';
import { useTrack } from '~/hooks/track';
import { EventsNames } from '~/enums/Events';

export const CustomerVerification = styled<React.FC<CustomerVerificationProps>>(({ className }) => {
  const userContext = React.useContext(UserContext);
  const errorDispatch = React.useContext(ErrorDispatchContext);
  const { track } = useTrack();

  const [isLoading, setIsLoading] = useState(true);
  const [isSmsPopupOpen, setIsSmsPopupOpen] = useState(false);

  const upstreamUrl = useMemo(() => {
    return addQueryParamsToUrl({ url: location.href, params: { customerVerified: 1 } });
  }, []);

  const [verificationLink, setVerificationLink] = useState<string>();

  useEffect(() => {
    track({ eventName: EventsNames.ExtraVerificationPageLoad });
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const requestPayload = { upstreamUrl };
        const { link } = (await applyOnlineNetworkService.getCustomerVerificationLink(requestPayload)) || {};
        if (isMobile) {
          window.location.replace(link);
        } else {
          setVerificationLink(link);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
        errorDispatch({ type: ActionTypes.ExtraVerification, error });
      }
    })();
  }, []);

  const onSendSmsClick = useCallback(async () => {
    try {
      setIsSmsPopupOpen(true);
      await applyOnlineNetworkService.sendSmsVerificationLink({ upstreamUrl });
    } catch (error) {
      setIsSmsPopupOpen(false);
      errorDispatch({ type: ActionTypes.ExtraVerification, error });
    }
  }, []);

  const onCloseSmsPopup = useCallback(() => {
    setIsSmsPopupOpen(false);
  }, []);

  if (isLoading) {
    return <Loader active />;
  }

  // If there is no verification link an error popup is shown
  if (!verificationLink) {
    return null;
  }

  return (
    <div {...{ className }}>
      <CustomerVerificationView {...{ verificationLink, onSendSmsClick, phoneNumber: userContext.user.phone, isSmsPopupOpen, onCloseSmsPopup }} />
    </div>
  );
})`
  ${CustomerVerificationStyle}
`;
